import styled from 'styled-components';

export const LayoutContentWrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  padding: 30px 20px;
  
  /* Required for floating pagination header & drag-sort (react-sortable-hoc) to work */
  /* overflow: clip; */
  /* overflow: hidden; */

  /* contain: paint; */

  @media only screen and (width <= 767px) {
    padding: 50px 20px;
  }

  @media (width <= 580px) {
    padding: 15px;
  }
`;
